module.exports = __webpack_public_path__ + "static/media/DMSans-Regular.c0cc8ad9.svg";